import React, {Component} from 'react';
import {siteAccessCode, siteName, siteAddress, siteCity, siteState, siteZip, 
  sitePropertyId, siteTZ} from '../database/apiv2SiteAccessor';
import SecondServer from '../database/SecondServer';
import TZDropdown, {tzDisplay} from '../Report/Controls/TimeZoneDropDown';
import {canWrite, cachedPerms} from "./SitePerms"
import {urlServerbyNode} from '../database/apiUrls'

import './overview.css'
import './SitePane.css'

const readOnly={'readOnly':"1"};

export default class SitePane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      readwrite: {...readOnly},
      name: "",
      streetaddr: "",
      city: "",
      state: "",
      zip: "",
      propertyId: "",
      tz: "",
    }
    this.saveEditMode = this.saveEditMode.bind(this)
    this.cancelEdit = this.cancelEdit.bind(this)
    this.handleEdit = this.handleEdit.bind(this)
  }
  componentDidMount() {
    this.initSiteState()
  }
  initSiteState () {
    const site = this.props?.getActiveSite();
    this.setState ({
      name: siteName(site) ?? "",
      streetaddr: siteAddress(site) ?? "",
      city: siteCity(site) ?? "",
      state: siteState(site) ?? "",
      zip: siteZip(site) ?? "",
      propertyId: sitePropertyId(site) ?? "",
      tz:tzDisplay(siteTZ(site)) ?? "",
    })
  }
  componentDidUpdate(prevProps) {
    //const newParam = tzDisplay(siteTZ(this.props?.getActiveSite()))
    //console.log (newParam)
  }
  handleEdit (evt) {
    let item = {}
    item[evt.target.id] = evt.target.value
    this.setState({...item})
    //console.log ("You changed ", evt.target.id, " to ", item.value);
  }
  
  textOutput (label, value) {
    const rw = this.state.readwrite
    return (
      <label className="form-label site-label">{label}
        <input type="text" value={value} id={value} className="form-control display-style" {...rw}/>
      </label>
    )
  }
  textInput (label, prop, className='') {
    const data = this.state[prop]
    const rw = this.state.readwrite
    const borderStyle = this.editMode() ? "display-style" : "input-border"
    return (
      <label className={"form-label site-label "+className}>{label}
        <input type="text" value={data} id={prop} className={"form-control "+borderStyle}  
          onChange={this.handleEdit} {...rw}/>
      </label>
    )
  }
  saveState () {
    const st = this.state
    const saveObj = {
      site_name: st.name,
      address: st.streetaddr,
      city: st.city,
      state: st.state,
      zipcode: st.zip,
      property_id: st.propertyId,
      utc_offset: siteTZ(this.props?.getActiveSite()) ?? ""
    }
    const site = this.props.getActiveSite()
    const url = "/tehama/sites/" + siteAccessCode(site);
    const ss = new SecondServer(this.props);
    ss.apiSaveData(url, saveObj);
    this.props.updateSiteListCache ('site_details', saveObj)
    const secondSave = {
      name: st.name,
    }
    const url2 = urlServerbyNode(site.nodeId)
    ss.apiSaveData(url2, secondSave)
  }
  editMode () {
    return Object.hasOwn(this.state.readwrite, 'readOnly')
  }
  saveEditMode () {
    if (!this.editMode ()) {
      this.saveState()
    }
    this.toggleEditMode()
  }
  toggleEditMode () {
    if (canWrite(cachedPerms(this.props.getActiveSite()))) {
      const newState = this.editMode() ? {} : readOnly
      this.setState({readwrite: newState})
    }
  }
  editLabel () {
    return this.editMode() ? "Edit" : "Save"
  }
  dependantLabel () {
    return this.editMode() ? "" : "Cancel"
  }
  cancelEdit () {
    this.initSiteState()
    this.toggleEditMode()
  }
  render () {
    const el = this.editLabel()
    const apiTZ = siteTZ(this.props?.getActiveSite()) ?? ""
    const tz = tzDisplay(apiTZ)
    return (
      <form className="site-form">
        <div className="site-edit se-placement" onClick={this.saveEditMode}>{el}</div>
        <div className="site-edit se-placement" onClick={this.cancelEdit}>{this.dependantLabel()}</div>
        {this.textInput("Site Name", 'name', "w-100 se-top")}
        {this.textInput("Address", 'streetaddr', "w-100")}
        <div className="row">
          <div className="col">{this.textInput("City", 'city')}</div>
          <div className="col">{this.textInput("State", 'state')}</div>
          <div className="col">{this.textInput("Zip Code", 'zip')}</div>
        </div>
        <div className="row">
          <div className="col-8">{this.textInput("Property ID", 'propertyId', 'w-100')}</div>
          <div className="col"> {this.editMode() ? 
            this.textOutput("Time Zone", tz)
            : <label className="form-label site-label">Time Zone
              <TZDropdown {...this.props} value={apiTZ} onUpdate={this.props.onUpdate} />
              </label>
            }
            </div>
        </div>
      </form>
    )
  }
}
